import script from "./CalendarWeek.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarWeek.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarWeek.vue?vue&type=style&index=0&id=9d90178a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d90178a"]])

export default __exports__